import { WfaLabelOptionsDistinctQuery } from 'src/apps/wfa/services/queries/label-options/WfaLabelOptionsDistinct.generated';
import { IWfaLabelOptions } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { ILabelConfig } from 'src/common/types/LabelsTypes';

export const filterLabelOptionsByConfig = (
	labelOptions: WfaLabelOptionsDistinctQuery['wfa_session_run_labels'],
	labelsConfig: ILabelConfig[]
): IWfaLabelOptions[] => {
	if (!labelOptions) {
		return [];
	}

	const optionsByKey = new Map(labelOptions.map((opt) => [opt.custom_field_key, opt]));

	const result = labelsConfig.flatMap((config) => {
		const opt = optionsByKey.get(config.key);
		if (!opt) {
			return [];
		}

		const configOptionsByKey = new Map(config.options.map((o) => [o.key, o.name]));
		return {
			labelKey: config.key,
			labelName: config.name,
			options: opt.custom_field_values.flatMap((v) =>
				configOptionsByKey.has(v) ? [{ value: v, label: configOptionsByKey.get(v) as string }] : []
			)
		};
	});

	return result;
};

export const getSortedLabelsConfig = (
	labelsConfig: ILabelConfig[],
	labelKeyOrder?: string[]
): ILabelConfig[] => {
	if (!labelKeyOrder) {
		return labelsConfig;
	}

	const configByKey = new Map(labelsConfig.map((c) => [c.key, c]));
	const ordered = labelKeyOrder.flatMap((key) => configByKey.get(key) ?? []);
	const rest = labelsConfig.filter((c) => !labelKeyOrder.includes(c.key));
	return [...ordered, ...rest];
};
